import {Component, Inject, PLATFORM_ID, ViewEncapsulation} from '@angular/core';
import { RouterModule } from '@angular/router';
import { AuthService } from '@coreApiServices';
import { SubscribersService, ToastService } from '@coreServices';
import { CommonConstants as Constants, ROUTES } from '@coreConstant';
import {CommonConstants} from "@coreConstant";
import { NgbModal, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { AuthComponent } from 'src/app/features/auth/auth.component';
import { Subject, takeUntil } from 'rxjs';
import { HandleImageErrorDirective } from 'src/app/core/directives/handle-image-error.directive';
import {isPlatformBrowser} from "@angular/common";

@Component({
    selector: 'app-footer',
    standalone: true,
    imports: [RouterModule, HandleImageErrorDirective,NgbTooltipModule],
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'], // corrected the typo here (styleUrl -> styleUrls)
    encapsulation: ViewEncapsulation.None
})
export class FooterComponent {
  currentYear: number = new Date().getFullYear();
  public isUserAuthenticated: boolean = true;
  protected readonly s3BucketUrl = Constants.IMAGE_KIT_ENDPOINT;
  protected readonly facebookUrl = Constants.SOCIAL_MEDIA_URLS.FACEBOOK;
  protected readonly instagramUrl = Constants.SOCIAL_MEDIA_URLS.INSTAGRAM;
  protected readonly pinterestUrl = Constants.SOCIAL_MEDIA_URLS.PINTEREST;
  productDetailClass = '';
  destroy$ = new Subject<void>();
  ROUTES = ROUTES;
  protected readonly CommonConstants = CommonConstants;

  constructor(
    private authService: AuthService,
    private subscriberService: SubscribersService,
    private ngbModal: NgbModal,
    private toastService: ToastService,
    @Inject(PLATFORM_ID) protected platformId: any,
  ) {
    this.isUserAuthenticated = this.authService.isUserAuthenticated();
    this.subscriberService.isUserLoggedIn.pipe(takeUntil(this.destroy$)).subscribe((options) => {
      this.isUserAuthenticated = options;
    });
  }

  ngOnInit() {
    this.subscriberService.isProductDetailPageSubject.pipe(takeUntil(this.destroy$)).subscribe((res) => {
      this.productDetailClass = res ? 'copyright-section-custom' : '';
    })
  }

  openSignUpModal() {
    const modelRef = this.ngbModal.open(AuthComponent, {scrollable: true, modalDialogClass: 'auth-modal'});
    modelRef.componentInstance.authModel = Constants.AUTH_MODAL_TYPES.REGISTER;
  }

  handleError() {
    this.toastService.showError(Constants.PREVENT_ACCESS_PRICE_LIST_ERROR_MESSAGE);
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

    protected readonly isPlatformBrowser = isPlatformBrowser;
}
